<template>
  <OrderDetailProducts :orderDetailProducts="orderDetailProducts" :onMoveProduct="onMoveProduct" />
</template>

<script>
import axios from 'axios'
import OrderDetailProducts from '../../layouts/organisms/OrderDetailProducts/index'
import { Location, MoveType, Action } from '@/plugins/AppManager'
import { NativeStorageKey } from '../../../../../plugins/NativeStorageManager'

export default {
  name: 'OrderDetailProductsContainer',
  props: {
    chatbot: Boolean
  },
  components: { OrderDetailProducts },
  computed: {
    orderDetailProducts() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].products
    }
  },
  methods: {
    async onMoveProduct(product) {
      if (this.chatbot) return

      try {
        const result = await this.$store.dispatch('myOrderHistoryDetailV2/checkServiceArea')

        const hasBmartIcon = result.success

        if (hasBmartIcon) {
          this.$appManager.move(Location.PRODUCT, this.$store.getters.isAndroid, MoveType.REPLACE, {
            marketProduct_ref: 'orderHistoryDetail',
            marketProduct_productId: product.productId
          })
        } else {
          this.$store.dispatch('modal/open', {
            type: 'NotServiceArea',
            message: '',
            onOK: async () => {
              this.$appManager.move(Location.HOME, this.$store.getters.isAndroid, MoveType.REPLACE)

              this.$store.dispatch('modal/close')
            },
            onCancel: async () => {
              this.$store.dispatch('modal/close')
            }
          })
        }
      } catch (err) {
        alert('인터넷 연결상태를 확인해주세요.')
        console.log(JSON.stringify(err))
      }
    }
  }
}
</script>